import React, { useEffect } from "react";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

import RightImage from "../../../../ASSETS/IMAGES/doctorsdiag.png";
import IconUndiag from "../../../../ASSETS/ICONS/icon1.png";
import IconTools from "../../../../ASSETS/ICONS/icon2.png";
import IconCost from "../../../../ASSETS/ICONS/icon3.png";
import IconKur from "../../../../ASSETS/ICONS/icon4.png";

const WhoAreWeSection = () => {
  useEffect(() => {
    AOS.init({ duration: 600, once: true });
  }, []);

  return (
    <section className="kp-hero">

      {/* TITLE */}
      <h1 className="kp-title">Transforming Preventive Care to a Higher Standard</h1>

      {/* TWO SEPARATE FRAMES */}
      <div className="kp-frame-wrapper">

        {/* LEFT FRAME: POINTS */}
        <div className="kp-frame-left" data-aos="fade-right">
          <div className="kp-bullets">

            <div className="kp-point">
              <div className="kp-iconWrap">
                <img src={IconUndiag} className="kp-icon" alt="" />
              </div>
              <p>
                Health conditions often go undiagnosed until symptoms become serious.
              </p>
            </div>

            <div className="kp-point">
              <div className="kp-iconWrap">
                <img src={IconTools} className="kp-icon" alt="" />
              </div>
              <p>
                Diagnostic solutions are often costly, complex & difficult to implement.
              </p>
            </div>

            <div className="kp-point">
              <div className="kp-iconWrap">
                <img src={IconCost} className="kp-icon" alt="" />
              </div>
              <p>
                Physicians need better tools to detect diseases before patients are in crisis.
              </p>
            </div>

            <div className="kp-point">
              <div className="kp-iconWrap">
                <img src={IconKur} className="kp-icon" alt="" />
              </div>
              <p>
                Clinics miss reimbursable revenue while patients miss life-saving care.
              </p>
            </div>

          </div>
        </div>

        {/* RIGHT FRAME: IMAGE */}
        <div className="kp-frame-right" data-aos="fade-left">
          <img src={RightImage} alt="Doctors" />
        </div>

      </div>

      {/* BOTTOM STATEMENT */}
      <h2 className="kp-bottom-text">
        KUR Diagnostics provides technology to make early detection affordable & standard in everyday care.
      </h2>

      {/* BUTTONS */}
      <div className="kp-buttons">
        <button
          className="kp-btn-outline"
          onClick={() => (window.location.href = "/screening_program")}
        >
          Click Here for Our Portfolio of Tests
        </button>

        <button
          className="kp-btn-primary"
          onClick={() => (window.location.href = "/partner_us")}
        >
          Click Here to Partner With Us
        </button>
      </div>
{/* METRICS BAR */}
<div className="kp-metrics">
  <div className="kp-metric">
    <div className="kp-m-num">130k+</div>
    <div className="kp-m-label">Patients screened</div>
  </div>

  <div className="kp-m-metric-divider"></div>

  <div className="kp-metric">
    <div className="kp-m-num">1.8%</div>
    <div className="kp-m-label">Readmission rate</div>
  </div>

  <div className="kp-m-metric-divider"></div>

  <div className="kp-metric">
    <div className="kp-m-num">4.5M</div>
    <div className="kp-m-label">Care hours delivered</div>
  </div>

  <div className="kp-m-metric-divider"></div>

  <div className="kp-metric">
    <div className="kp-m-num">No Capital</div>
    <div className="kp-m-label">Cost to practice</div>
  </div>
</div>

    </section>
  );
};

export default WhoAreWeSection;
